import React from 'react';
import { getFileIcon, formatFileSize, getFileConfig } from '../../config/appConfig';

const FileQueueItem = ({ 
  fileItem, 
  onRemove
}) => {
  const getStatusBadge = (status) => {
    const badges = {
      pending: { class: 'bg-secondary', text: 'Pendiente' },
      uploading: { class: 'bg-primary', text: 'Subiendo...' },
      completed: { class: 'bg-success', text: 'Completado' },
      error: { class: 'bg-danger', text: 'Error' }
    };
    return badges[status] || badges.pending;
  };

  const statusBadge = getStatusBadge(fileItem.status);

  return (
    <div 
      className="d-flex flex-column align-items-start bg-light rounded-3 p-3 position-relative border hover:shadow-sm transition-all fade-in"
      style={{ minWidth: '200px', maxWidth: '280px' }}
    >
      <div className="d-flex align-items-center w-100">
        <i className={`${getFileIcon(fileItem.type)} me-3 fs-4`}></i>
        <div className="flex-grow-1 me-2" style={{ minWidth: 0 }}>
          <div 
            className="fw-medium text-truncate mb-1" 
            title={fileItem.name}
            style={{ fontSize: '0.9rem' }}
          >
            {fileItem.name}
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <small className="text-muted fw-medium">{formatFileSize(fileItem.size)}</small>
            <span className={`badge ${statusBadge.class}`} style={{ fontSize: '0.65rem' }}>
              {statusBadge.text}
            </span>
          </div>
        </div>
        <button
          className="btn btn-sm btn-outline-danger position-absolute rounded-circle d-flex align-items-center justify-content-center"
          style={{ 
            top: '-8px', 
            right: '-8px', 
            width: '24px', 
            height: '24px', 
            padding: '0',
            fontSize: '0.7rem'
          }}
          onClick={() => onRemove(fileItem.id)}
          title="Remover archivo"
        >
          <i className="bi bi-x"></i>
        </button>
      </div>
      {/* Barra de progreso individual */}
      {(fileItem.status === 'uploading' || fileItem.status === 'completed') && (
        <div className="progress mt-2 w-100" style={{ height: '6px' }}>
          <div
            className={`progress-bar ${fileItem.status === 'completed' ? 'bg-success' : 'bg-primary'}${fileItem.status === 'uploading' ? ' progress-bar-striped progress-bar-animated' : ''}`}
            role="progressbar"
            style={{ width: `${fileItem.progress || 0}%` }}
            aria-valuenow={fileItem.progress || 0}
            aria-valuemin="0"
            aria-valuemax="100"
          >
          </div>
        </div>
      )}   
    </div>
  );
};

const FileQueue = ({ 
  uploadedFiles, 
  onRemoveFile, 
  onClearAll
}) => {
  if (uploadedFiles.length === 0) {
    return (
      <div className="border rounded-3 p-4 bg-light text-center text-muted">
        <i className="bi bi-inbox display-6 mb-3 text-muted"></i>
        <h6 className="mb-2">No hay archivos en cola</h6>
        <small>Los archivos aparecerán aquí una vez que los selecciones</small>
      </div>
    );
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="col-8 mb-0 align-items-center">
          <i className="bi bi-files me-2 text-primary"></i>
          Archivos en Cola 
          <span className="badge bg-primary ms-2">{uploadedFiles.length}/{getFileConfig().MAX_FILES}</span>
        </h6>
        <button 
          className="btn btn-sm btn-outline-danger"
          onClick={onClearAll}
        >
          <i className="bi bi-trash me-1"></i>
          Limpiar Cola
        </button>
      </div>
      
      <div 
        className="border rounded-3 p-3 bg-white shadow-sm custom-scrollbar" 
        style={{ maxHeight: '300px', overflowY: 'auto' }}
      >
        <div className="d-flex flex-wrap gap-3">
          {uploadedFiles.map((fileItem) => (
            <FileQueueItem
              key={fileItem.id}
              fileItem={fileItem}
              onRemove={onRemoveFile}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default FileQueue;
